import type {CrmNodeFieldKey} from 'src/types/crm-node';


export type CrmNodeFieldOption = {
  key: CrmNodeFieldKey;
  label: string;
  i18nKey: string;
  enumValues?: readonly string[];
};

// Hardcoded for now. This list is intended to be served by the backend
// separately in a follow-up; keep the shape (key/label/i18nKey/enumValues) so
// the backend-driven options can drop in without touching the task UI.
export const CRM_NODE_FIELD_OPTIONS: CrmNodeFieldOption[] = [
  // contact
  {key: 'contact_id', label: 'Contact ID', i18nKey: 'Contact_ID'},
  {key: 'contact_name', label: 'Contact Name', i18nKey: 'Contact_Name'},
  {key: 'contact_email', label: 'Contact Email', i18nKey: 'Contact_Email'},
  {key: 'contact_phone', label: 'Contact Phone', i18nKey: 'Contact_Phone'},

  // company
  {key: 'company_name', label: 'Company Name', i18nKey: 'Company_Name'},
  {key: 'job_title', label: 'Job Title', i18nKey: 'Job_Title'},

  // lead
  {
    key: 'lead_status',
    label: 'Lead Status',
    i18nKey: 'Lead_Status',
    enumValues: ['new', 'contacted', 'qualified', 'unqualified'],
  },
  {key: 'lead_source', label: 'Lead Source', i18nKey: 'Lead_Source'},

  // deal
  {
    key: 'deal_stage',
    label: 'Deal Stage',
    i18nKey: 'Deal_Stage',
    enumValues: [
      'prospecting',
      'qualification',
      'proposal',
      'negotiation',
      'closed_won',
      'closed_lost',
    ],
  },
  {key: 'deal_amount', label: 'Deal Amount', i18nKey: 'Deal_Amount'},

  // ownership / meta
  {key: 'owner_id', label: 'Owner ID', i18nKey: 'Owner_ID'},
  {key: 'notes', label: 'Notes', i18nKey: 'Notes'},
  {
    key: 'last_contacted_at',
    label: 'Last Contacted At',
    i18nKey: 'Last_Contacted_At',
  },
  {key: 'created_at', label: 'Created At', i18nKey: 'Created_At'},

  // my fields

  {
    key: 'agencyId',
    label: 'Agency ID',
    i18nKey: 'Agency_ID',
  },
  {
    key: 'jobCandidateId',
    label: 'Job Candidate ID',
    i18nKey: 'Job_Candidate_ID',
  },
  {
    key: 'senseJobSubmissionId',
    label: 'Sense Job Submission ID',
    i18nKey: 'Sense_Job_Submission_ID',
  },
  {
    key: 'source',
    label: 'Source',
    i18nKey: 'Source',
  },
  {
    key: 'initiatedBy',
    label: 'Initiated By',
    i18nKey: 'Initiated_By',
  },
  {
    key: 'callStatus',
    label: 'Call Status',
    i18nKey: 'Call_Status',
  },
  {
    key: 'conversationId',
    label: 'Conversation ID',
    i18nKey: 'Conversation_ID',
  },
  {
    key: 'evaluationScore',
    label: 'Evaluation Score',
    i18nKey: 'Evaluation_Score',
  },
  {
    key: 'evaluationCompletedOn',
    label: 'Evaluation Completed On',
    i18nKey: 'Evaluation_Completed_On',
  },
  {
    key: 'evaluationSummary',
    label: 'Evaluation Summary',
    i18nKey: 'Evaluation_Summary',
  },
  {
    key: 'screeningOwnerId',
    label: 'Screening Owner ID',
    i18nKey: 'Screening_Owner_ID',
  },
  {
    key: 'screeningOwnerType',
    label: 'Screening Owner Type',
    i18nKey: 'Screening_Owner_Type',
  },
  {
    key: 'screeningSourceId',
    label: 'Screening Source ID',
    i18nKey: 'Screening_Source_ID',
  },
  {
    key: 'conversationTranscript',
    label: 'Conversation Transcript',
    i18nKey: 'Conversation_Transcript',
  },
  {
    key: 'failureReason',
    label: 'Failure Reason',
    i18nKey: 'Failure_Reason',
  },
];
